import { createSelector } from 'reselect';
import { allSerieHistory } from '../../reducers/Question/serie.reducer';

const selectSeriesState = (state) => state.series;

export const selectSerieHistory = createSelector(
    [selectSeriesState],
    (series) => series[allSerieHistory]
);
